module.exports = __webpack_public_path__ + "media/images/payment/mastercard-electronic-ea68d963bdc291fdafe5b9c234d1ab3d.png";